import { cartItemEmpty, type CartItem } from "@/event/cartBus"
import { ref } from "vue"

export const messageAlertElementBasketHappyEmpty = {
    message: "",
    product_name: "",
    product: cartItemEmpty
}

export interface iMessageAlertElementBasketHappyEmpty {
    message: string
    product_name: string
    product: CartItem
}

export const messageAlertElementBasketHappy = ref<iMessageAlertElementBasketHappyEmpty>(messageAlertElementBasketHappyEmpty)

function getRemoveProductMessage(productName: string): { message: string, productName: string } {
    return {
        message: `Voulez-vous supprimer ce produit :`,
        productName: productName + ' ?'
    }
}

export function setRemoveProductMessage(product: CartItem) {
    const productName = product.product
    messageAlertElementBasketHappy.value = {
        message: getRemoveProductMessage(productName).message,
        product_name: getRemoveProductMessage(productName).productName,
        product: product
    }
}

export const clearMessageAlertElementHappy = () => {
    messageAlertElementBasketHappy.value = messageAlertElementBasketHappyEmpty;
};